"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialFilterOperator = exports.customFilterOperator = exports.localStorageKey = exports.formatGridDate = exports.filterOperator = exports.sidebarStyle = exports.navbarStyle = exports.subMenuList = exports.fixedZIndex = exports.sortMonth = exports.pathList = exports.month = exports.color = void 0;
const color = {
    darkRed: '#B5192A',
    redDark: '#BA352C',
    red: '#EA0927',
    redDisable: '#ba352c80',
    darkDisable: '#00808080',
    white: '#FFF',
    gray: '#F0F0F0',
    darkGrey: '#575757',
    lightGray: '#888888',
    black: '#000000',
    semiWhite: '#F7F7F7',
    borderGrey: '#d7d7d7',
    softGrey: '#AAAAAA',
    navy: '#26285A',
    neutralLight: '#253858',
    buttonLight: '#ff6702',
    buttonDark: '#008080',
    sidebarDark: '#272936',
    sidebarLight: '#323232',
    sidebarTitleDark: '#323232',
    sidebarItemDark: '#EDEDED',
    sidebarItemSelected: '#EDEDED',
    sidebarItemActiveDark: '#5F6275',
    sidebarItemInactiveDark: '#34374A',
    sidebarItemActiveLight: '#575757',
    sidebarItemInactiveLight: '#9B9B9B',
    backgroundDark: '#313443',
    gridColumnDark: '#303345',
    gridColumnDarkAlt: '#272936',
};
exports.color = color;
const fixedZIndex = {
    modal: 9,
    navbar: 8,
    sidebar: 7,
};
exports.fixedZIndex = fixedZIndex;
const sidebarStyle = {
    menuWidth: '250px',
    menuWidthColapse: '75px',
    menuHeight: '100vh',
};
exports.sidebarStyle = sidebarStyle;
const navbarStyle = {
    width: '100vw',
    height: '65px',
};
exports.navbarStyle = navbarStyle;
const pathList = {
    dashboard: {
        path: '/dashboard',
        subModule: {
            silo: '/silo',
            hopper: '/hopper',
            stockpile: '/stockpile',
            contractorPerformance: '/contractor-performance',
            haulingPerformance: '/hauling-performance',
            deviceManager: '/device-manager',
        },
    },
    masterData: {
        path: '/master-data',
        subModule: {
            contractor: '/contractor',
            dtNumber: '/dt-number',
            excavator: '/excavator',
            area: '/area',
            pit: '/pit',
            seam: '/seam',
            silo: '/silo',
            brand: '/brand',
            vessel: '/vessel',
            driver: '/driver',
            hauler: '/hauler',
            stockpile: '/stockpile',
            hopper: '/hopper',
        },
    },
    userAccess: {
        path: '/user-access',
        subModule: {
            user: '/user',
            roleMapping: '/role-mapping',
        },
    },
    stockPile: { path: '/stockpile' },
    posStockpile: { path: '/choose-pos-stockpile' },
    silo: { path: '/silo' },
    posHopper: { path: '/choose-pos-hopper' },
    posSilo: { path: '/choose-pos-silo' },
    hopper: {
        path: '/hopper',
        subModule: {
            l100: '/L-100',
            l200: '/L-200',
            l300: '/L-300',
            l400: '/L-400',
            l500: '/L-500',
        },
    },
    cctv: {
        path: '/cctv-center',
    },
    report: {
        path: '/report',
        subModule: {
            statistic: '/statistic',
            hauling: '/hauling-operation',
            pitOperation: '/pit-operation',
            attendance: '/operator-attendance',
            haulingStatistic: '/hauling-statistic',
            production: '/production-statistic'
        }
    },
    configuration: {
        path: '/configuration',
        subModule: {
            haulerManager: '/hauler-manager',
            stockpile: '/stockpile',
            pitOperation: '/pit-operation',
            siloConfig: '/silo',
            hopperConfig: '/hopper-control-line',
            rfidTag: '/rfid-tag'
        }
    },
    dailySummary: {
        path: '/daily-summary',
        subModule: {
            silo: '/silo',
            hopper: '/hopper',
            stockpile: '/stockpile',
        }
    },
    adjustment: {
        path: '/adjustment',
        subModule: {
            silo: '/silo',
            dayoff: '/day-off',
            rfidlog: '/rfid-log',
            planning: '/planning',
            stockpile: '/stockpile',
        }
    },
    coalChainSimulationReport: {
        path: '/coal-chain-simulation-report',
    },
    bgLoadingAndTranshipment: { path: '/bgloading' },
};
exports.pathList = pathList;
const userAccessSubMenu = [
    {
        title: 'User',
        subMenuName: 'User',
        selected: false,
        show: true,
        path: pathList.userAccess.subModule.user,
    },
    {
        title: 'User Role',
        subMenuName: 'User Role',
        selected: false,
        show: true,
        path: pathList.userAccess.subModule.roleMapping,
    },
];
const masterDataSubMenu = [
    {
        title: 'Contractor',
        subMenuName: 'Contractor',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.contractor,
    },
    {
        title: 'PIT',
        subMenuName: 'Pit',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.pit,
    },
    {
        title: 'Area',
        subMenuName: 'Area',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.area,
    },
    {
        title: 'Seam',
        subMenuName: 'Seam',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.seam,
    },
    {
        title: 'Coal Brand',
        subMenuName: 'Coal Brand',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.brand,
    },
    {
        title: 'Stockpile',
        subMenuName: 'Stockpile',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.stockpile,
    },
    {
        title: 'Silo',
        subMenuName: 'Silo',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.silo,
    },
    {
        title: 'Hopper',
        subMenuName: 'Hopper',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.hopper,
    },
    {
        title: 'Excavator',
        subMenuName: 'Excavator',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.excavator,
    },
    {
        title: 'Dump Truck',
        subMenuName: 'Dump Truck',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.dtNumber,
    },
    {
        title: 'Hauler',
        subMenuName: 'Hauler',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.hauler,
    },
    {
        title: 'Vessel',
        subMenuName: 'Vessel',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.vessel,
    },
    {
        title: 'Driver',
        subMenuName: 'Driver',
        selected: false,
        show: true,
        path: pathList.masterData.subModule.driver,
    },
];
const hopperSubMenu = [
    {
        title: 'L-100',
        subMenuName: 'L100',
        selected: false,
        show: true,
        path: pathList.hopper.subModule.l100,
    },
    {
        title: 'L-200',
        subMenuName: 'L200',
        selected: false,
        show: true,
        path: pathList.hopper.subModule.l200,
    },
    {
        title: 'L-300',
        subMenuName: 'L300',
        selected: false,
        show: true,
        path: pathList.hopper.subModule.l300,
    },
    {
        title: 'L-400',
        subMenuName: 'L400',
        selected: false,
        show: true,
        path: pathList.hopper.subModule.l400,
    },
    {
        title: 'L-500',
        subMenuName: 'L500',
        selected: false,
        show: true,
        path: pathList.hopper.subModule.l500,
    },
];
const reportSubMenu = [
    {
        title: 'Production Data', subMenuName: 'Production Data',
        selected: false, show: true, path: pathList.report.subModule.production
    },
    {
        title: 'Hauling Data', subMenuName: 'Hauling Data',
        selected: false, show: true, path: pathList.report.subModule.haulingStatistic
    },
    {
        title: 'Pit Operation', subMenuName: 'Pit Operation',
        selected: false, show: true, path: pathList.report.subModule.pitOperation
    },
    {
        title: 'Hauling Operation', subMenuName: 'Hauling Operation',
        selected: false, show: true, path: pathList.report.subModule.hauling
    },
    {
        title: 'Op. Attendance', subMenuName: 'Op. Attendance',
        selected: false, show: true, path: pathList.report.subModule.attendance
    },
    {
        title: 'Coal Statistic', subMenuName: 'statistic',
        selected: false, show: true, path: pathList.report.subModule.statistic
    },
];
const configurationSubMenu = [
    {
        title: 'Pit Operation',
        subMenuName: 'Pit Operation',
        selected: false,
        show: true,
        path: pathList.configuration.subModule.pitOperation,
    },
    {
        title: 'Hauler',
        subMenuName: 'Hauler',
        selected: false,
        show: true,
        path: pathList.configuration.subModule.haulerManager,
    },
    {
        title: 'Stockpile',
        subMenuName: 'Stockpile',
        selected: false,
        show: true,
        path: pathList.configuration.subModule.stockpile,
    },
    {
        title: 'Silo',
        subMenuName: 'Silo',
        selected: false,
        show: true,
        path: pathList.configuration.subModule.siloConfig,
    },
    {
        title: 'Hopper Control Line',
        subMenuName: 'Hopper',
        selected: false,
        show: true,
        path: pathList.configuration.subModule.hopperConfig,
    },
    {
        title: 'RFID Tag',
        subMenuName: 'RFID Tag',
        selected: false,
        show: true,
        path: pathList.configuration.subModule.rfidTag,
    }
];
const dailySummarySubMenu = [
    {
        title: 'Stockpile',
        subMenuName: 'Stockpile',
        selected: false,
        show: true,
        path: pathList.dailySummary.subModule.stockpile,
    },
    {
        title: 'Silo',
        subMenuName: 'Silo',
        selected: false,
        show: true,
        path: pathList.dailySummary.subModule.silo,
    },
    {
        title: 'Hopper',
        subMenuName: 'Hopper',
        selected: false,
        show: true,
        path: pathList.dailySummary.subModule.hopper,
    },
];
const adjustmentSubMenu = [
    {
        title: 'Actual Production',
        subMenuName: 'Actual Production',
        selected: false,
        show: true,
        path: pathList.adjustment.subModule.stockpile,
    },
    {
        title: 'Actual Hauling',
        subMenuName: 'Actual Hauling',
        selected: false,
        show: true,
        path: pathList.adjustment.subModule.silo,
    },
    {
        title: 'Planning',
        subMenuName: 'Planning',
        selected: false,
        show: true,
        path: pathList.adjustment.subModule.planning,
    },
    {
        title: 'Day Off',
        subMenuName: 'Day Off',
        selected: false,
        show: true,
        path: pathList.adjustment.subModule.dayoff,
    },
    {
        title: 'RFID Log',
        subMenuName: 'RFID Log',
        selected: false,
        show: true,
        path: pathList.adjustment.subModule.rfidlog,
    }
];
const dashboardSubMenu = [
    {
        title: 'Stockpile',
        subMenuName: 'Stockpile',
        selected: false,
        show: true,
        path: pathList.dashboard.subModule.stockpile,
    },
    {
        title: 'Silo',
        subMenuName: 'Silo',
        selected: false,
        show: true,
        path: pathList.dashboard.subModule.silo,
    },
    {
        title: 'Hopper',
        subMenuName: 'Hopper',
        selected: false,
        show: true,
        path: pathList.dashboard.subModule.hopper,
    },
    {
        title: 'Coal Performance',
        subMenuName: 'Coal Performance',
        selected: false,
        show: true,
        path: pathList.dashboard.subModule.contractorPerformance,
    },
    {
        title: 'Hauling Performance',
        subMenuName: 'Hauling Performance',
        selected: false,
        show: true,
        path: pathList.dashboard.subModule.haulingPerformance,
    },
    {
        title: 'Device Monitoring',
        subMenuName: 'Device Monitoring',
        selected: false,
        show: true,
        path: pathList.dashboard.subModule.deviceManager,
    },
];
const subMenuList = {
    hopperSubMenu,
    reportSubMenu,
    dashboardSubMenu,
    masterDataSubMenu,
    userAccessSubMenu,
    adjustmentSubMenu,
    dailySummarySubMenu,
    configurationSubMenu,
};
exports.subMenuList = subMenuList;
const filterOperator = {
    contains: 'contains',
    notContains: 'doesnotcontain',
    startWith: 'startswith',
    endWith: 'endswith',
    eq: 'eq',
    neq: 'neq',
    gt: 'gt',
    lt: 'lt',
    gte: 'gte',
    lte: 'lte',
};
exports.filterOperator = filterOperator;
const customFilterOperator = {
    text: [
        { text: 'grid.filterContainsOperator', operator: filterOperator.contains },
        { text: 'grid.filterNotContainsOperator', operator: filterOperator.notContains },
        { text: 'grid.filterEqOperator', operator: filterOperator.eq },
        { text: 'grid.filterStartsWithOperator', operator: filterOperator.startWith },
        { text: 'grid.filterEndsWithOperator', operator: filterOperator.endWith },
    ],
    numeric: [
        { text: 'grid.filterEqOperator', operator: filterOperator.eq },
        { text: 'grid.filterNotEqOperator', operator: filterOperator.neq },
        { text: 'grid.filterGteOperator', operator: filterOperator.gte },
        { text: 'grid.filterGtOperator', operator: filterOperator.gt },
        { text: 'grid.filterLteOperator', operator: filterOperator.lte },
        { text: 'grid.filterLtOperator', operator: filterOperator.lt },
    ],
    date: [
        { text: 'grid.filterEqOperator', operator: filterOperator.eq },
        { text: 'grid.filterNotEqOperator', operator: filterOperator.neq },
        { text: 'grid.filterAfterOrEqualOperator', operator: filterOperator.gte },
        { text: 'grid.filterAfterOperator', operator: filterOperator.gt },
        { text: 'grid.filterBeforeOperator', operator: filterOperator.lt },
        { text: 'grid.filterBeforeOrEqualOperator', operator: filterOperator.lte },
    ],
    boolean: [{ text: 'grid.filterEqOperator', operator: 'eq' }],
};
exports.customFilterOperator = customFilterOperator;
const specialFilterOperator = {
    text: [
        { text: 'grid.filterContainsOperator', operator: filterOperator.contains, viewText: 'Contains' },
        { text: 'grid.filterContainsOperator', operator: filterOperator.eq, viewText: 'Equals' },
        { text: 'grid.filterNotContainsOperator', operator: filterOperator.notContains, viewText: 'Does not Contain' },
        { text: 'grid.filterStartsWithOperator', operator: filterOperator.startWith, viewText: 'Starts with' },
        { text: 'grid.filterEndsWithOperator', operator: filterOperator.endWith, viewText: 'Ends with' },
    ],
    numeric: [
        { text: 'grid.filterEqOperator', operator: filterOperator.eq, viewText: 'Is Equal to' },
        { text: 'grid.filterNotEqOperator', operator: filterOperator.neq, viewText: 'Is not Equal to' },
        { text: 'grid.filterGteOperator', operator: filterOperator.gte, viewText: 'Is Greater than or Equal to' },
        { text: 'grid.filterGtOperator', operator: filterOperator.gt, viewText: 'Is Greater than' },
        { text: 'grid.filterLteOperator', operator: filterOperator.lte, viewText: 'Is Less than or Equal to' },
        { text: 'grid.filterLtOperator', operator: filterOperator.lt, viewText: 'Is Less than' },
    ],
    date: [
        { text: 'grid.filterEqOperator', operator: filterOperator.eq, viewText: 'Is Equal to' },
        { text: 'grid.filterNotEqOperator', operator: filterOperator.neq, viewText: 'Is not Equal to' },
        { text: 'grid.filterAfterOrEqualOperator', operator: filterOperator.gte, viewText: 'Is After or Equal to' },
        { text: 'grid.filterAfterOperator', operator: filterOperator.gt, viewText: 'Is After' },
        { text: 'grid.filterBeforeOperator', operator: filterOperator.lt, viewText: 'Is Before' },
        { text: 'grid.filterBeforeOrEqualOperator', operator: filterOperator.lte, viewText: 'Is Befor or Equal to' },
    ],
    boolean: [{ text: 'grid.filterEqOperator', operator: 'eq', viewText: 'Is Equal to' }]
};
exports.specialFilterOperator = specialFilterOperator;
const formatGridDate = {
    hhMM: '{0:HH:mm}',
    hhMMss: '{0:HH:mm:ss}',
    ddMMYYYY: '{0:dd-MM-yyyy}',
    ddMMyyyy: '{0:dd/MM/yyyy}',
    ddMMyyyyHHmm: '{0:dd-MM-yyyy HH:mm}',
    hhMMString: '{0:HH} Hours {0:mm} Minutes'
};
exports.formatGridDate = formatGridDate;
const localStorageKey = {
    token: '@userToken',
    userData: '@userData',
    themeApp: '@themeApp',
    isAuthenticated: '@userIsAuth',
    defaultPassword: '@defaultPassword',
};
exports.localStorageKey = localStorageKey;
const month = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];
exports.month = month;
const sortMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
exports.sortMonth = sortMonth;
